export default __webpack_public_path__ + "static/media/login-bg-41.430a4150.jpg";